import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ICompany } from '../typing/company.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { CompanyService } from './company.service';

@Injectable({
    providedIn: 'root'
})
export class CompanySelectorService {

    constructor(private companyService: CompanyService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.companyService.getCompanies(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<ICompany>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(group => ({
            label: group.name,
            value: group.id,
            tooltip: this.getTooltip(group),
        }));

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.companyService.getCompany(Number(optionValue)).pipe(
            filter(group => !!group),
            map(group => ({
                label: group.name as string,
                value: group.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: ICompany): string {
        return (value.name ? value.name : '') + (value.id ? '; id:' + value.id : '') ;
    }

}
